module.exports = __webpack_public_path__ + "assets/1e64d6b7e9c130e6ae347eef8457648c.mp3";